/**
 * Текущее время, обновляемое раз в intervalMs.
 *
 * «Пора»/«просрочен» на карточках должны наступать сами, без событий с
 * сервера: время идёт и на молчащем пульте. Один хук на список контактов и
 * карточку, чтобы оба красились по одним часам.
 */
import { useEffect, useState } from 'react';

export function useNow(intervalMs: number): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => {
      setNow(new Date());
    }, intervalMs);
    return () => {
      clearInterval(id);
    };
  }, [intervalMs]);
  return now;
}
